module.exports = __webpack_public_path__ + "img/img8.8f9de087.png";